<template lang="pug">
  div
    .main
      .row
        .col-md-6.col-lg-5.col-xl-4
          h2.title 数据总览-微信营业厅
</template>

<script>
export default {
  name: 'dashboard-businessCharges'
}
</script>

<style lang="sass" scoped>
</style>



// WEBPACK FOOTER //
// WechatBusinessHall.vue?1ea4766a